// extracted by mini-css-extract-plugin
export var container = "_9e-0";
export var error = "_9e-9";
export var label = "_9e-5";
export var light = "_9e-6";
export var md = "_9e-3";
export var sm = "_9e-2";
export var thin = "_9e-8";
export var thinBold = "_9e-7";
export var vertical = "_9e-4";
export var xs = "_9e-1";